import { render } from "./JasaKonstruksi.vue?vue&type=template&id=0a4bd02e"
import script from "./JasaKonstruksi.vue?vue&type=script&lang=js"
export * from "./JasaKonstruksi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__